{
  "receive.heading": "Receive",
  "receive.description": "Questa pagina mostra lo stato, il ciclo e il numero di contenitori e colli nel processo di ricezione",
  "receive.filter.title": "Opzioni",
  "receive.filter.cycle": "Ciclo",
  "receive.current_planned": "Attuale pianificato",
  "receive.current_actual": "Attuale Arrivato Attuale",
  "receive.other": "Altro/Non pianificato Arrivato Effettivo",
  "receive.overall_status": "Stato complessivo",
  "receive.packages": "Pacchi",
  "CPT.": "CPT",
  "CPT.cpt": "CPT",
  "CPT.induct_by": "Indotto da",
  "CPT.stow_by": "Fermati vicino",
  "package.cpt": "CPT",
  "receive.predicted_dispatch": "Predetto manifestato",
  "receive.total_manifested": "Manifesto totale",
  "receive.container_planned_volume": "Volume pianificato container",
  "receive.current_cycle_planned": "Ciclo corrente pianificato",
  "receive.current_cycle_actual": "Ciclo corrente effettivo",
  "receive.other_cycles": "Altri cicli",
  "receive.total": "Totale",
  "receive.current_status": "Stato corrente",
  "receive.manifested": "Partenza in sospeso da processo a monte",
  "receive.in_transit": "In transito da processo a monte",
  "receive.arrived": "Induct in sospeso",
  "receive.marked_for_reprocess": "Ripetizione induct in sospeso",
  "receive.inducted": "Indotto",
  "receive.stow_buffered": "Stow con buffer",
  "receive.stowed": "Stoccato",
  "receive.sidelined": "In sideline",
  "receive.group_by": "Raggruppa per",
  "linehaul.linehauls": "Linehaul",
  "linehaul.status": "Stato",
  "linehaul.arrival": "Arrivo",
  "linehaul.details": "Dettagli",
  "linehaul.vrid": "VRID",
  "linehaul.origin": "Origine",
  "linehaul.location": "Posizione",
  "linehaul.planned": "Pianificato",
  "linehaul.actual": "Effettivo",
  "linehaul.volume": "Volume",
  "linehaul.FMC": "FMC",
  "linehaul.unloadSequence": "Scarica sequenza",
  "linehaul.inyard": "Nell'area di sosta",
  "linehaul.arrived": "Arrivato",
  "linehaul.incoming": "In arrivo",
  "linehaul_detail.receive": "Receive",
  "linehaul_detail.linehaul_details": "Dettagli Linehaul",
  "linehaul_detail.linehaul": "Linehoul ",
  "linehaul_detail.from": "Da",
  "linehaul_detail.departed": "Partito",
  "linehaul_detail.arrived": "Arrivato",
  "linehaul_detail.options": "Opzioni",
  "linehaul_detail.id": "ID",
  "linehaul_detail.type": "Tipo",
  "linehaul_detail.pending_induct": "Induct in sospeso ",
  "linehaul_detail.total": "Totale ",
  "linehaul_filter.packagesize": "Dimensione pacco",
  "linehaul_filter.ead": "Stazione EAD",
  "linehaul_filter.cycle": "Ciclo",
  "linehaul_filter.cluster": "Cluster",
  "linehaul_filter.otherattributes": "Altri attributi",
  "linehaul_filter.clear_all": "Cancella tutto",
  "induct.heading": "Induct",
  "induct.description": "Questa pagina mostra lo stato, il ciclo e il numero di contenitori e confezioni nel processo di induzione",
  "induct.induct": "Induct",
  "induct.induct_area": "Aree induct",
  "induct.active_associate": "Associate attivi",
  "induct.induct_rate": "Velocità di induct",
  "induct.total_inducted": "Totale indotti",
  "induct.container": "Container",
  "induct.container_id": "ID",
  "induct.type": "Tipo",
  "induct.pending_induct": "Induct in sospeso ",
  "induct.total": " Totale",
  "induct.aslInductArea": "ASL Area di Induct",
  "induct.max_induct_rate": "Massimo Induct Rate",
  "induct.station_percentage": "% Volume Totale",
  "induct.successful_percentage": "% Scansionati Correttamente",
  "induct.kickout": "Kickout",
  "induct.noread": "NoRead",
  "induct.timeout": "Timeout",
  "induct.failed_verification": "Failed Verification",
  "induct.sidelined": "Sidelined",
  "induct.cycle": "Ciclo",
  "associate.heading": "Induct soci",
  "associate.description": "Questa pagina mostra i dati sulle prestazioni degli associati di induct e la posizione di lavoro corrente",
  "associate.option": "Opzioni",
  "associate.active": "Attivo",
  "associate.associates": "Associate",
  "associate.associate": "Associate",
  "associate.pph": "PPH",
  "associate.hours": "Ore",
  "associate.total_packages": "Totale pacchi",
  "associate.location": "Posizione",
  "associate.inactive_period": "Periodo inattivo",
  "package.package_summary": "Riepilogo pacchi",
  "package.tracking_id": "ID tracciabilità",
  "package.last_scan_date_time": "Ultima scansione",
  "package.minutes_in_state": "Minuti in Stato",
  "package.package_state": "Stato",
  "package.package_reason": "Motivo",
  "package.location": "Posizione",
  "package.cycle": "Ciclo",
  "package.sort_zone": "Zona sort",
  "package.cluster": "Cluster",
  "package.EAD": "Stazione EAD",
  "package.size": "Dimensioni",
  "package.station_code": "Destinazione",
  "package.package_list": "Elenco pacchi",
  "induct.error": "Si è verificato un errore",

  "generic.error": "Alcuni errori si sono verificati",
  "generic.enabled" : "Abilitato",
  "generic.disabled" : "Disabilitato",
  "generic.close": "Vicino",
  "tooltip.max_induct_rate": "Massimo induct rate della macchina ASL",
  "tooltip.induct_rate": "Numero medio di pacchi ricevuti ogni ora dalla macchina ASL",
  "tooltip.total_inducted": "Total number of packages inducted",
  "tooltip.station_percentage": "Percentuale del volume totale ricevuto dalla macchina ASL",
  "tooltip.successful_percentage": "Percentuale di pacchi ricevuti con successo dalla macchina ASL",
  "tooltip.kickout": "Numero di pacchi non ricevuti con successo dalla macchina ASL",
  "tooltip.noread": "Numero di pacchi con problemi di lettura barcode",
  "tooltip.timeout": "Numero di pacchi con problemi di ricezione dovuti a latenze di sistema",
  "tooltip.stowbuffered_cycle": "Spedizioni che si trovano attualmente in questo stato di pacco e sono state stoccate correttamente nel buffer durante questo ciclo",
  "tooltip.failed_verification": "Numero di pacchi con problemi di verifica della telecamera in uscita",
  "tooltip.non_conveyable_description": "NC: Packages that exceed 42'' in a single dimension. \n FCLM might have different dimension criteria for NC",

  "header.induct_management": "Gestione dell'indotto",
  "induct_management.induct_setup": "Induct Setup",
  "induct_management.select_cycle": "Seleziona ciclo",
  "induct_management.current_sort_cycle": "Ciclo di ordinamento corrente",
  "induct_management.current_cycle_state": "Stato del ciclo corrente",
  "induct_management.current_force_induct_status": "Stato attuale dell'indice di forza",
  "induct_management.enable_force_induct": "Abilita induzione forzata",
  "induct_management.sort_cycle": "Ordina ciclo",
  "induct_management.force_induct_sort_cycle": "Forza l'induzione di tutti i pacchetti ricevuti nel ciclo di ordinamento corrente",
  "induct_management.start_sort_cycle": "Avvia Induct",
  "induct_management.container_plan_failure" : "Si è verificato un errore durante il salvataggio del ciclo di induzione. Per favore riprova più tardi",
  "induct_management.mapped_cycles_failure" : "Si è verificato un errore durante il recupero dei cicli attivi. Per favore riprova più tardi",
  "induct_management.set_node_operational_failure" : "Si è verificato un errore durante il salvataggio del ciclo di induzione. Per favore riprova più tardi",
  "induct_management.get_node_operational_failure" : "Si è verificato un errore durante l'acquisizione delle informazioni sul ciclo di ordinamento corrente. Per favore riprova più tardi",
  "induct_management.non_mco_station" : "Questa pagina non è ancora abilitata per la tua stazione. Se la tua stazione supporta operazioni multiciclo, resta sintonizzato per ulteriori aggiornamenti :-)",
  "induct_management.bad_request" : "Seleziona il ciclo corretto dal menu a discesa",
  "induct_management.set_node_induct_process_details_success" : "Induct Cycle è stato avviato con successo",
  "induct_management.no_active_container_plans_available" : "Non ci sono piani di container attivi configurati per questa stazione, per favore riprova più tardi",
  "induct_management.pick_started_for_the_current_cycle" : "Il prelievo è stato avviato per il ciclo corrente, quindi l'indotto è bloccato",
  "induct_management.start_induct" : ". Modificare per correggere il ciclo e avviare il processo di induzione.",
  "common.data_last_updated": "Ultimo aggiornamento dei dati",
  "inductmanagement.heading": "Gestione del ciclo di induzione",
  "inductmanagement.description": "Questa pagina consente di modificare le impostazioni del ciclo di induzione",
  "inductmanagement.manage_cycle": "Gestisci cicli",
  "inductmanagement.force_induct": "Induzione della forza",
  "inductmanagement.active_until": "Attivo fino al",
  "inductmanagement.noCycles": "Nessun ciclo disponibile",
  "inductmanagement.disableCycle": "Disabilita ciclo",
  "inductmanagement.enableCycle": "Abilita ciclo",
  "inductmanagement.enterCycle": "Entra nel ciclo...",
  "inductmanagement.enterStationCode": "Inserisci il codice della stazione...",
  "inductmanagement.noStations": "Nessuna stazione disponibile",
  "inductmanagement.selectStatus": "Seleziona lo stato...",
  "inductmanagement.enableForceInduct": "Abilita l'induzione della forza",
  "inductmanagement.disableForceInduct": "Disabilita forza induzione",
  "inductmanagement.activateSortToRouteError": "Impossibile attivare un altro ciclo di tipo SORT_TO_ROUTE. {cycle} è già attivo.",
  "inductmanagement.activateCycleError": "Si è verificato un errore durante l'attivazione del ciclo: {cycle}",
  "inductmanagement.deactivateCycleError": "Si è verificato un errore durante la disattivazione del ciclo: {cycle}",
  "inductmanagement.unselectedWarning": "Seleziona un nodo e fai un ciclo prima di fare clic su Attiva",
  "inductmanagement.setForceError": "Si è verificato un errore durante l'aggiornamento dell'induzione della forza per il ciclo: {cycleName}",
  "inductmanagement.submit": "Invia",
  "inductconfig.noActiveLanes": "Tutte le corsie sono inattive o di trattenimento, nessuna corsia rimasta per pallet o carrelli.",
  "inductconfig.noCartLanes": "Tutte le corsie sono inattive, di trattenimento o pallet. Nessuna corsia rimasta per i carrelli.",
  "inductconfig.noBeltsConfigured": "Nessun nastro di induzione configurato. Aggiungere almeno un nastro.",
  "inductconfig.holdLaneWarning": "Nessuna corsia di trattenimento configurata. I contenitori non possono essere trattenuti durante questo ciclo. Vuoi procedere?",
  "inductconfig.singleBeltWarning": "Solo un nastro attivo configurato. Se questo nastro si guasta, nessun pacco può essere indotto. Vuoi procedere?",
  "inductconfig.inactiveHoldOverlap": "La/le corsia/e inattiva/e {lanes} non possono essere anche nelle corsie di trattenimento.",
  "inductconfig.inactivePalletOverlap": "La/le corsia/e inattiva/e {lanes} non possono essere anche nelle corsie pallet.",
  "inductconfig.palletLanes": "Corsie Pallet",
  "inductconfig.priorityLaneCount": "Numero Corsie Prioritarie",
  "inductconfig.priorityLaneCountHint": "Inserire il numero di corsie prioritarie (es. 25)",
  "inductconfig.beltNoContainerTypes": "Uno o più nastri non hanno tipi di contenitore selezionati. Seleziona almeno un tipo di contenitore per ogni nastro.",
  "inductconfig.beltNoCubeTypes": "Uno o più nastri non hanno tipi di cubo selezionati. Seleziona almeno un tipo di cubo per ogni nastro.",
  "inductconfig.noActiveBelts": "Nessun nastro di induzione attivo configurato. Almeno un nastro deve essere attivo per elaborare i pacchi.",
  "inductconfig.containerTypeNotCovered": "Uno o più tipi di contenitore non sono assegnati a nessun nastro attivo. Tutti i tipi di contenitore devono essere coperti da almeno un nastro attivo.",
  "inductconfig.cubeTypeNotCovered": "Uno o più tipi di cubo non sono assegnati a nessun nastro attivo. Tutti i tipi di cubo devono essere coperti da almeno un nastro attivo.",
  "inductconfig.invalidLaneEntered": "Corsia non valida inserita. Inserire un identificatore di corsia valido.",
  "inductconfig.selectCycleBeforeUpload": "Selezionare un ciclo prima di eseguire il caricamento.",
  "inductconfig.invalidCycleInCsv": "Ciclo non valido o mancante nel CSV. Inserire un ciclo valido."
}
